<template>
    <div class="container">
        <h1 class="title">
            Discord server
        </h1>
        <div class="columns">
            <div class="column is-half">
                <div class="content">
                    <p>
                        If you want to report a bug, request a feature, have any other kind of feedback or just stop by
                        to chat about the game or our tools, feel free to
                        <a href="https://discord.gg/rNXRS6ZkYe">join our Discord server</a>.
                    </p>
                    <a href="https://discord.gg/rNXRS6ZkYe">
                        <img src="https://discordapp.com/api/guilds/543804828808249374/widget.png?style=banner3" alt="Discord">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'discord',
    }
</script>
